<template>
  <FormItem prop="value" :show-message="false" :rules="rules">
    <p class="sub-title title desc-style">
      <span class="qu-num"  v-if="answerStyleConfig.common.showQuNumInd === '1'">{{`${config.quCode}.`}}</span>
      <span v-if="config.answerConfig.requireInd === '1'" class="require">*</span>
      <span class="qu-title" v-html="config.displayTitle"></span>
      <span v-if="answerStyleConfig.common.showQuestionType === '1'" class="qu-type">
        (<span v-html="config.displayElementDesc"></span>)
      </span>
      <template v-if="config.imgUrl">
        <ipsos-av class="sub-title-img" v-if="isAv(config.imgUrl)" :src="config.imgUrl"></ipsos-av>
        <ipsos-image class="sub-title-img" v-else :imgUrl="config.imgUrl" :preview="config.id || config.displayTitle"></ipsos-image>
      </template>
    </p>
    <div :class="`desc-swiper-container ${config.answerConfig.scoreVerification === '1' ? 'score-repeat-tips' : ''}`">
      <!-- <div class="desc-swiper-prev" :class="prevSwiper ? 'prev-swiping' : ''"></div>
      <swiper class="desc-swiper" :options="swiperOption" ref="swiper">
        <swiper-slide
          class="swiper-slide"
          v-for="(desc, index) in config.descList"
          :key="desc.id + 'slider'"
        >
          <div class="desc-list" :class="desc.imgUrl ? 'img-title' : 'no-img'">
            <div class="desc-head">
              <slot name="descTitle" :model="desc" :index="index">
                <div class="desc-title">
                  <span class="qu-num">{{`${config.quNum}.${index + 1}`}}</span>
                  <span>{{desc[modelKey]}}</span>
                </div>
              </slot>
              <ipsos-image :imgUrl="desc.imgUrl" :preview="desc.id"></ipsos-image>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="desc-swiper-next" :class="nextSwiper ? 'next-swiping' : ''"></div> -->
      <div class="desc-swiper" ref="swiper">
        <!-- 矩阵题显示 -->
        <div v-if="config.descList.length && ['3', '4', '6'].includes(config.scoreQuType)" class="rate-matrix-top">
          <!-- 滑块题-双击量表  -->
          <div v-if="['3'].includes(config.scoreQuType)" class="top">
            <div class="item left-item">
              <span class="arrow"></span>
              {{config.optionList[0].displayTitle}}
            </div>
            <div class="item center-item">
              {{config.optionList[1].displayTitle}}
            </div>
            <div class="item right-item">
              <span class="arrow"></span>
              {{config.optionList[2].displayTitle}}
            </div>
          </div>
          <!-- 滑块题-滑块、NPS  -->
          <div v-if="['4', '6'].includes(config.scoreQuType)" class="top">
            <div class="item left-item">
              <span class="arrow"></span>
              {{config.optionList[0].displayTitle}}
            </div>
            <div class="item right-item">
              <span class="arrow"></span>
              {{config.optionList[1].displayTitle}}
            </div>
          </div>
        </div>
        <div
          class="wyb"
          :class="[{'matrix-star': config.scoreQuType === '2'}]"
          v-for="(desc, index) in config.descList"
          :key="desc.id + 'slider'"
        >
          <div v-if="desc.visibility" class="desc-list title" :class="desc.imgUrl ? 'img-title' : 'no-img'">
            <div class="desc-head">
              <slot name="descTitle" :model="desc" :index="index">
                <p class="desc-title desc-style">
                  <!-- <span class="qu-num"  v-if="answerStyleConfig.common.showQuNumInd === '1'">{{`${config.quCode}.${index + 1}`}}</span> -->
                  <span class="qu-title" v-html="desc[modelKey]"></span>
                  <!-- {{desc[modelKey]}} -->
                </p>
              </slot>
              <!-- <ipsos-image :imgUrl="desc.imgUrl" :preview="desc.id"></ipsos-image> -->
              <template v-if="desc.imgUrl">
                <ipsos-av class="sub-title-img" v-if="isAv(desc.imgUrl)" :src="desc.imgUrl"></ipsos-av>
                <ipsos-image class="sub-title-img" v-else :imgUrl="desc.imgUrl" :preview="desc.id || desc.displayTitle"></ipsos-image>
              </template>
            </div>
          </div>
          <!-- 重复评分个数提示 -->
          <div v-if="config.answerConfig.scoreVerification === '1'" :id="`desc-item-tips-${config.id}-${index}`" class="repeat-tips-txt">{{ cvtLang(config.id + 'scoreRepeatTips', config.answerConfig.scoreRepeatTips) }}</div>
          <slot v-if="desc.visibility" name="optionList" :model="desc" :index="index" :crtDescIndex="crtDescIndex"></slot>
        </div>
      </div>
    </div>
    <!-- <div
      class="an-body animated fadeIn"
      v-show="crtDescIndex === index"
      v-for="(desc, index) in config.descList"
      :key="desc.id"
    >
      <slot name="optionList" :model="desc" :index="index" :crtDescIndex="crtDescIndex"></slot>
    </div> -->
  </FormItem>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'AnswerSwipeDescList',
  props: ['config', 'rules', 'modelKey'],
  data () {
    var vm = this
    return {
      swiperDirect: '',
      crtModel: {},
      crtDescIndex: 0,
      nextSwiper: false,
      prevSwiper: false,
      swiperOption: {
        loop: vm.config.descList.length !== 1,
        autoHeight: true,
        on: {
          slideChange: function () {
            const realIndex = this.realIndex
            vm.crtDescIndex = realIndex
            vm.config.crtDescIndex = realIndex
          },
          slideNextTransitionStart: function () {
            vm.nextSwiper = true
          },
          slideNextTransitionEnd: function () {
            vm.nextSwiper = false
          },
          slidePrevTransitionStart: function () {
            vm.prevSwiper = true
          },
          slidePrevTransitionEnd: function () {
            vm.prevSwiper = false
          }
        },
        navigation: {
          nextEl: '.desc-swiper-next',
          prevEl: '.desc-swiper-prev'
        }
      }
    }
  },
  components: {},
  watch: {
    'config.descList': {
      deep: true,
      handler () {
        this.execRepeatValid()
      }
    },
  },
  computed: {
    ...mapState({
      answerStyleConfig: ({Question}) => Question.answerStyleConfig,
      langMap: ({Question}) => Question.langMap,
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang // 基础语言配置（提示文字、按钮、题型）
    }),
    maxIndex () {
      return this.config.descList.length
    },
    swiper () {
      return this.$refs.swiper.swiper
    }
  },
  methods: {
    execRepeatValid() {
      const { answerConfig: { scoreVerification, scoreRepeatNum }, descList } = this.config
      const descPropValid = sessionStorage.getItem('descPropValid')
      let currIndex = 0
      if (descPropValid && descPropValid.split('.')) {
        currIndex = Number(descPropValid.split('.')[1])
      }
      const descItemTips = document.getElementById(`desc-item-tips-${this.config.id}-${currIndex}`)
      let descListFilter = this.config.descList.filter(item => item.visibility)
      // reset
      for(let i=0; i<descListFilter.length; i++) {
        if (document.getElementById(`desc-item-tips-${this.config.id}-${i}`)) {
          document.getElementById(`desc-item-tips-${this.config.id}-${i}`).style.display = 'none'
        }
      }

      if (scoreVerification === '1') {
        const currVal = descListFilter[currIndex].value
        const valArr = descListFilter.filter(item => item.value).map(item => (item.value))
        const someVal = valArr.filter(item => item === currVal)
        if (someVal.length >= scoreRepeatNum) {
          descItemTips.style.display = 'block'
        } else {
          descItemTips.style.display = 'none'
        }
      }
    },
    isAv (url) {
      return url && url.includes('.mp4')
    },
    canSwipe () {
      return this.maxIndex !== 1
    },
    swipeRight (e) {
      if (this.canSwipe()) {
        --this.crtDescIndex < 0 && (this.crtDescIndex = this.maxIndex - 1)
        this.swiper.slideTo(this.crtDescIndex)
      }
    },
    swipeLeft () {
      if (this.canSwipe()) {
        ++this.crtDescIndex > this.maxIndex - 1 && (this.crtDescIndex = 0)
        this.swiper.slideTo(this.crtDescIndex)
      }
    },
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    },
  },
  created () {},
  mounted () {
    this.config.crtDescIndex = this.crtDescIndex
  }
}
</script>
<style lang="scss">
.swipe-box-answer {
  .desc-swiper-container {
    display: flex;
    // margin-bottom: 34px;
    .desc-swiper-prev,
    .desc-swiper-next {
      z-index: 2;
      outline: none;
      width: 60px;
      position: relative;
    }

    .desc-swiper-prev {
      background: url(../../assets/images/answer/slider-graybox-lef@2x.png)
        no-repeat;
      background-size: 100% 100%;
      opacity: 0.53;
    }

    .desc-swiper-prev::before {
      content: '';
      width: 76px;
      height: 94px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%) rotate(180deg);
      background: url(../../assets/images/answer/slider-right@2x.png)
        no-repeat;
      background-size: 100% 100%;
    }

    .desc-swiper-next {
      background: url(../../assets/images/answer/slider-graybox-rig@2x.png)
        no-repeat;
        opacity: 0.53;
      background-size: 100% 100%;
    }

    .desc-swiper-next::before {
      content: '';
      width: 76px;
      height: 94px;
      position: absolute;
      top: 50%;
      left: -16px;
      transform: translateY(-50%);
      background: url(../../assets/images/answer/slider-right@2x.png)
        no-repeat;
      background-size: 100% 100%;
    }

    .prev-swiping, .next-swiping {
      opacity: 1;
    }

    .desc-swiper {
      flex: 1;
      .rate-matrix-top {
        margin-top: 40px;
        .top {
          display: flex;
          justify-content: space-between;
          margin-bottom: 50px;
          .item {
            background: #f2f2f2;
            border-radius: 8px;
            color: rgba(0, 0, 0, 0.45);
            padding: 0 20px;
            font-size: 24px;
            line-height: 48px;
            position: relative;
            .arrow {
              width: 0px;
              height: 0px;
              border-width: 0px 10px 10px 0px;
              border-style: solid;
              border-color: transparent #f2f2f2;
            }
          }
          .left-item {
            border-end-start-radius: 0;
            .arrow {
              position: absolute;
              left: 0;
              bottom: -9px;
              border-width: 0px 0px 10px 10px;
            }
          }
          .right-item {
            border-end-end-radius: 0;
            .arrow {
              position: absolute;
              right: 0;
              bottom: -9px;
            }
          }
        }
      }
      .wyb {
        margin-bottom: 40px;
        .desc-list {
          margin-top: 30px;
        }
        &.matrix-star {
          .rate-wrapper {
            margin: 0;
          }
        }
        .repeat-tips-txt {
          font-size: 24px;
          display: none;
        }
      }
      .desc-list {
        background: rgba(255, 255, 255, 1);
        // border: 1px solid #C2C2C2;
        display: flex;
        justify-content: center;
        align-items: center;

        .desc-head {
          width: 100%;
          .qu-num {
            font-size: 16px;
          }

          .desc-title {
            // line-height: 16px;
            font-size: 28px;
            line-height: 44px;
            //font-family: PingFang-SC-Medium;
            font-weight: 500;
            color: rgba(51, 52, 46, 1);
            margin-bottom: 20px;
          }
        }
      }

      .desc-list.no-img {
        .desc-head {
          .qu-num {
            font-size: 16px;
          }
          .desc-title {
            // line-height: 16px;
            font-size: 28px;
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .desc-list, .desc-style {
    .video-player {
      width: auto !important;
    }
  }

  .answer-container .answer-wrapper {
    // padding-left: 0 !important;
    // padding-right: 0 !important;

    .an-head {
      .title {
        // padding: 0 60px;
        padding: 0;
      }
      .require {
        font-size: 36px;
        color: #FF645A;
      }
      .sub-title {
        font-size: 32px;
        padding-bottom: 40px;
        border-bottom: 1px solid #f1f1f1;
        .qu-title {
          font-size: 32px;
        }
      }
      .qu-type {
        font-size: 24px;
        color: #bbb;
      }
    }

    .an-body .an-body {
      padding: 0 60px;
    }

    .ivu-form-item-error-tip {
      padding-left: 60px;
      padding-right: 60px;
    }
  }

  .desc-container {
    display: flex;

    .content {
      flex: 1;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(171, 171, 171, 1);
      img {
        padding: 0 30px 40px 30px;
      }
    }
  }
}
.answer-pc {
  .swipe-box-answer {
    .answer-container .answer-wrapper {
      .an-head {
        .title {
          padding: 0 30px;
          .require {
            font-size: 18px;
            color: #FF645A;
          }
        }
        .sub-title {
          font-size: 16px;
          padding-bottom: 20px;
          .qu-title {
            font-size: 18px;
          }
        }
        .qu-type {
          font-size: 16px;
        }
      }

      .an-body .an-body {
        padding: 0 60px;
      }
      .desc-swiper-container {
        padding: 15px 40px 10px 80px;
        margin-bottom: -30px;
        .desc-swiper {
          .rate-matrix-top {
            width: 70%;
            margin-top: 20px;
            .top {
              margin-bottom: 25px;
              .item {
                border-radius: 4px;
                padding: 0 10px;
                font-size: 12px;
                line-height: 24px;
                .arrow {
                  border-width: 0px 5px 5px 0px;
                }
              }
              .left-item {
                border-end-start-radius: 0;
                .arrow {
                  bottom: -4px;
                  border-width: 0px 0px 5px 5px;
                }
              }
              .right-item {
                border-end-end-radius: 0;
                .arrow {
                  bottom: -4px;
                }
              }
            }
          }
          .wyb {
            margin-bottom: 20px;
            .desc-list {
              margin-top: 15px;
              margin-bottom: 10px;
            }
            &.matrix-star {
              &:last-child {
                margin-bottom: 30px !important;
              }
            }
            .repeat-tips-txt {
              font-size: 12px;
              margin-top: -10px;
            }
          }
          .desc-list {
            padding: 0px;
            margin-top: 0px;
            .desc-head {
              .desc-title {
                // line-height: 16px;
                font-size: 14px;
                line-height: 22px;
                // margin-bottom: 25px;
              }
            }
          }
        }
      }
      .ivu-form-item-error-tip {
        padding-left: 60px;
        padding-right: 60px;
      }
    }
  }
  .desc-list, .desc-style {
    .av-wrap {
      width: 70% !important;
    }
    .video-player {
      width: 100% !important;
    }
    .video-js {
      width: 100% !important;
      height: 250px !important;
    }
  }
}
  // 矩阵滑块 星星题最后一个元素缩掉
 .wyb:nth-last-child(1) {
   margin: 0px 0px 10px 0px !important;
 }
</style>



// WEBPACK FOOTER //
// src/components/answer/AnswerSwipeDescList.vue